import React from 'react';
import clsx from 'clsx';
import {Grid} from '@mui/material';
import { Card, Typography } from '@curves/ui-base';

import {ReadTextField} from '@Local/Components';
/**
 * 訂單店鋪資訊區塊組件
 *
 * 功能：
 * - 顯示訂單相關的店鋪資訊
 * - 包含分店名稱、地址等資訊
 *
 * @component
 * @param {Object} props - 組件屬性
 * @param {string} props.className - 自定義樣式類名
 * @param {Object} props.infoData - 訂單資料
 * @returns {JSX.Element} 店鋪資訊區塊
 */
const OrderClubInfoSection = ({className, infoData}) => {
    return (
        <>
            <Card className={clsx("px-3 pt-2 pb-3", className)}>
                <Card.CardContent>
                    <Typography variant="body1" className={'mb-2'}>
                        銷售店鋪資訊
                    </Typography>
                    <Grid spacing={2} container>
                        <Grid xs={6} item>
                            <ReadTextField label="分店名稱">
                                {infoData?.clubName}
                            </ReadTextField>
                        </Grid>
                        <Grid xs={6} item>
                            <ReadTextField label="銷售人員/教練">
                                {infoData?.employeeDisplayName}
                            </ReadTextField>
                        </Grid>
                    </Grid>
                </Card.CardContent>
            </Card>
        </>
    )
};
export default OrderClubInfoSection;
